import { elevation, themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { createAccountStyles } from "@dana/Overrides/Widgets/CreateAccount/CreateAccount";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

createAccountStyles.requirementsTitle = mergeToNew(createAccountStyles.requirementsTitle, {
    variant: "h6",
    as: "h6",
});
createAccountStyles.form = mergeToNew(createAccountStyles.form, {
    css: css``,
});

createAccountStyles.mainGridContainer = mergeToNew(createAccountStyles.mainGridContainer, {
    gap: 0,
});

createAccountStyles.accordionGridItemWrapper = mergeToNew(createAccountStyles.accordionGridItemWrapper, {
    width: 12,
});

createAccountStyles.accordionHeadGridItem = mergeToNew(createAccountStyles.accordionHeadGridItem, {
    css: css`
        dl {
            padding: 10px 60px;
            border-inline-start: none;
            border-inline-end: none;
        }
    `,
});

createAccountStyles.radioGroupcontentWrapper = mergeToNew(createAccountStyles.radioGroupcontentWrapper, {
    css: css`
        width: 100%;
    `,
});

createAccountStyles.accordionHeadGridItemWrapper = mergeToNew(createAccountStyles.accordionHeadGridItemWrapper, {
    css: css`
        
        border-color: ${themeBackgrounds.lightGray};
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 8px 0px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        margin: auto;
                        width: 100%;
                    `,
                ],
                "min",
            )}
    `,
});
createAccountStyles.accordionHeadGridItem = mergeToNew(createAccountStyles.accordionHeadGridItem, {
    headerProps: {
        css: css`
            width: 100%;
            background: transparent;

            && > button {
                padding: 25px;
                border-inline-start: none;
                border-inline-end: none;
                border-color: ${themeBackgrounds.lightGray};

                &:focus {
                    border-color: ${themeBackgrounds.lightGray};
                    border-style: solid;
                    border-top-width: 1px;
                    border-bottom-width: 1px;
                    border-inline-end: none;
                    border-inline-start: none;
                    outline: 0;
                    padding: 25px;
                }
            }
        `,
    },
    panelProps: {
        css: css`
            border: none;
            &[class*="AccordionSectionPanel"] + [class*="AccordionSectionHeader"] {
                button:focus {
                    padding: 25px;
                }
            }
        `,
    },
});

createAccountStyles.danaUserBoxGroupWrapper = mergeToNew(createAccountStyles.danaUserBoxGroupWrapper, {
    css: css`
        flex-direction: row;
        column-gap: 16px;
        legend {
            display: none;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        column-gap: 24px;
                    `,
                ],
                "min",
            )}
    `,
});

createAccountStyles.danaUserBoxWrapper = mergeToNew(createAccountStyles.danaUserBoxWrapper, {
    css: css`
        display: flex;
        input {
            appearance: none;
            margin: 0;
            & + label {
                border: 1px solid ${themeBackgrounds.lightGray};
                padding: 21px 8px;
                border-radius: 8px;
                gap: 5px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                width: 155px;
                text-align: center;
                margin: 0;
                min-height: 112px;

                &:before,
                &:after {
                    display: none;
                }
                svg {
                    width: 30px;
                    height: 30px;
                }
                .boldLabel {
                }
            }
            &:checked {
                & + label {
                    gap: 5px;
                    &:before,
                    &:after {
                        display: none;
                    }

                    svg {
                        path {
                            fill: ${themeColors.primary.white};
                        }
                    }
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        input {
                            & + label {
                                padding: 20px 8px;
                                min-height: 112px;
                                width: 177px;
                            }
                        }
                    `,
                ],
                "min",
            )}

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        input {
                            & + label {
                                padding: 20px 8px;
                                width: 155px;
                                min-height: 85px;
                            }
                        }
                    `,
                    null,
                ],
                "max",
            )}
    `,
});

createAccountStyles.danaRadioMethodWrapper = mergeToNew(createAccountStyles.danaRadioMethodWrapper, {
    css: css`
        position: relative;
        width: 155px;
        color: ${themeBackgrounds.darkGray};
        text-transform: uppercase;
        > .checkIcon {
            display: none;
            position: absolute;
            right: 8px;
            top: 8px;
        }
        &:not(.active):hover {
            input {
                & + label {
                    border-color: ${themeBackgrounds.lightGray};
                    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 8px 0px;
                }
            }
        }
        &:not(.active):hover,
        &.active {
            > .checkIcon {
                display: block;
                color: ${themeColors.primary.white};
            }
        }
        &.active {
            input {
                & + label {
                    background-color: ${themeColors.primary.danaBlue};
                    color: ${themeColors.primary.white};
                    text-transform: uppercase;
                    padding: 20px 5px;
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        width: 177px;
                    `,
                ],
                "min",
            )}

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 155px;
                    `,
                    null,
                ],
                "max",
            )}
    `,
});

createAccountStyles.userGridItem = mergeToNew(createAccountStyles.userGridItem, {
    width: 12,
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding: 15px 0px;
                    `,
                ],
                "min",
            )}
    `,
});

createAccountStyles.emailGridItem = mergeToNew(createAccountStyles.emailGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.confirmEmailGridItem = mergeToNew(createAccountStyles.confirmEmailGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.userNameGridItem = mergeToNew(createAccountStyles.userNameGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.customerAccountNumberGridItem = mergeToNew(createAccountStyles.customerAccountNumberGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.firstNameGridItem = mergeToNew(createAccountStyles.firstNameGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.lastNameGridItem = mergeToNew(createAccountStyles.lastNameGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.passwordGridItem = mergeToNew(createAccountStyles.passwordGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.confirmPasswordGridItem = mergeToNew(createAccountStyles.confirmPasswordGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.addressLine1GridItem = mergeToNew(createAccountStyles.addressLine1GridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.addressLine2GridItem = mergeToNew(createAccountStyles.addressLine2GridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.companyNameGridItem = mergeToNew(createAccountStyles.companyNameGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.countryGridItem = mergeToNew(createAccountStyles.countryGridItem, {
    width: [12, 12, 6, 6, 6],
});

createAccountStyles.postalCodeGridItem = mergeToNew(createAccountStyles.postalCodeGridItem, {
    width: [12, 12, 4, 4, 4],
});

createAccountStyles.stateGridItem = mergeToNew(createAccountStyles.stateGridItem, {
    width: [12, 12, 4, 4, 4],
});

createAccountStyles.cityGridItem = mergeToNew(createAccountStyles.cityGridItem, {
    width: [12, 12, 4, 4, 4],
});

createAccountStyles.phoneGridItem = mergeToNew(createAccountStyles.phoneGridItem, {
    width: [12, 12, 4, 4, 4],
});

createAccountStyles.faxGridItem = mergeToNew(createAccountStyles.faxGridItem, {
    width: [12, 12, 4, 4, 4],
});

createAccountStyles.backGridItem = mergeToNew(createAccountStyles.backGridItem, {
    width: 12,
    css: css`
        gap: 10px;
        justify-content: end;
    `,
});

createAccountStyles.nextGridItem = mergeToNew(createAccountStyles.nextGridItem, {
    width: 12,
    css: css`
        justify-content: end;
        justify-content: end;
    `,
});

createAccountStyles.customerSelectionGridItem = mergeToNew(createAccountStyles.customerSelectionGridItem, {
    width: 12,
});

createAccountStyles.accountInformationGridItem = mergeToNew(createAccountStyles.accountInformationGridItem, {
    width: [12, 12, 6, 6, 6],
    css: css`
        gap: 5px;
        position: relative;
        padding: 20px;
        width: 100%;
        border: 1px solid ${themeBackgrounds.lightGray};
        border-radius: 8px;
        flex-direction: column;
        border-color: ${themeBackgrounds.lightGray};
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 8px 0px;
    `,
});

createAccountStyles.billingInformationGridItem = mergeToNew(createAccountStyles.billingInformationGridItem, {
    width: [12, 12, 6, 6, 6],

    css: css`
        gap: 5px;
        position: relative;
        padding: 20px;
        border: 1px solid ${themeBackgrounds.lightGray};
        border-radius: 8px;
        flex-direction: column;
        width: 100%;
        border-color: ${themeBackgrounds.lightGray};
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 8px 0px;
    `,
});

// createAccountStyles.accountInformationGridContainer = mergeToNew(createAccountStyles.accountInformationGridContainer, {
//     gap: 40,
//     css: css`
//         ${({ theme }: { theme: BaseTheme }) =>
//             breakpointMediaQueries(
//                 theme,
//                 [
//                     null,
//                     null,
//                     css`
//                         max-width: 1280px;
//                     `,
//                 ],
//                 "min",
//             )}
//     `,
// });

createAccountStyles.accountInformationGridItemWrapper = mergeToNew(
    createAccountStyles.accountInformationGridItemWrapper,
    {
        width: 12,
        css: css`
            gap: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        //    css`
                        //         flex-direction: row;
                        //     `,
                        //     css`
                        //         flex-direction: row;
                        //     `,
                    ],
                    "max",
                )}
        `,
    },
);

createAccountStyles.editIconWrapper = mergeToNew(createAccountStyles.editIconWrapper, {
    css: css`
        position: absolute;
        right: 20px;
        top: 32px;
        cursor: pointer;
        transform: translateY(-50%);

        &:hover {
            svg {
                path {
                    fill: ${themeColors.secondary.danaBrightBlue};
                }
            }
        }

        &:focus,
        &:focus-visible {
            outline: none;
            border: 1px solid ${themeColors.primary.white};
            box-shadow: ${elevation.focus};
        }
    `,
});

createAccountStyles.privacyPolicyCheckbox = mergeToNew(createAccountStyles.privacyPolicyCheckbox, {
    css: css`
        span[role="checkbox"] {
            border: 2px solid ${themeColors.primary.danaBlue};
            width: 20px;
            height: 20px;
            top: 0px;
            position: absolute;

            &[aria-checked="true"]:not([aria-disabled="true"]),
            &[aria-checked="mixed"]:not([aria-disabled="true"]) {
                background: ${themeColors.primary.danaBlue};
            }

            &:focus {
                outline: none;
                box-shadow: none;
            }
        }
            &[aria-checked="true"]:not([aria-disabled="true"]),
            &[aria-checked="mixed"]:not([aria-disabled="true"]) {
                background: ${themeColors.primary.danaBlue};
            }

            &:focus {
                outline: none;
                box-shadow: none;
            }
        }

        .privacy-policy span {
            color: ${themeColors.primary.danaBlue};
            padding-left: 5px;
            padding-right: 5px;
        }
        .terms-of-use span {
            color: ${themeColors.primary.danaBlue};
            padding-left: 5px;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        label {
                            flex-direction: column;
                        }
                    `,
                    null,
                ],
                "max",
            )}
    `,
});

createAccountStyles.privacyPolicyCheckboxGroup = mergeToNew(createAccountStyles.privacyPolicyCheckboxGroup, {
    css: css`
        .tooltip-wrapper {
            position: relative;
            display: inline-block;
        }
        .tooltip-wrapper {
            position: relative;
            display: inline-block;
        }

        .tooltip-text {
            visibility: hidden;
            width: 300px;
            background-color: ${themeColors.primary.white};
            color: ${themeColors.primary.richBlack};
            box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 8px 0px;
            text-align: center;
            padding: 16px;
            position: absolute;
            z-index: 1;
            top: -62px;
            left: 28%;
            transform: translateX(-50%);
            opacity: 0;
            transition: opacity 0.3s;
            font-size: 14px;
        }

        .tooltip-text::after {
            content: "";
            position: absolute;
            top: 100%;
            left: 8%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #333 transparent transparent transparent;
        }

        .tooltip-wrapper:hover .tooltip-text {
            visibility: visible;
            opacity: 1;
        }

        span[role="checkbox"] + label {
            margin-left: 25px;
            display: block;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        .tooltip-text {
                            visibility: hidden;
                            width: 300px;
                            background-color: ${themeColors.primary.white};
                            color: ${themeColors.primary.richBlack};
                            box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 8px 0px;
                            text-align: center;
                            padding: 16px;
                            position: absolute;
                            z-index: 1;
                            top: -62px;
                            left: calc(100px + 2.2rem);
                            transform: translateX(-50%);
                            opacity: 0;
                            transition: opacity 0.3s;
                            font-size: 14px;
                        }
                    `,
                    null,
                ],
                "max",
            )}
    `,
});

createAccountStyles.accountInformationHeaderVariant = {
    weight: 500,
    css: css`
        margin-bottom: 0px;
        color: ${themeBackgrounds.darkGray};
    `,
};

createAccountStyles.emailVericficationModelPopup = mergeToNew(createAccountStyles.emailVericficationModelPopup, {
    cssOverrides: {
        modalTitle: css`
            display: none;
        `,
        modalContent: css`
            gap: 15px;
            display: flex;
            flex-direction: column;
        `,
    },

    size: 900,
});

createAccountStyles.individualCustomerVericficationModelPopup = mergeToNew(
    createAccountStyles.individualCustomerVericficationModelPopup,
    {
        size: 900,

        cssOverrides: {
            modalTitle: css`
                display: inherit;
                border-bottom: 1px solid gray;
                justify-content: flex-start;
                gap: 5px;
                padding: 25px;

                &div {
                    justify-content: left !important;
                }

                span {
                    float: left;
                    margin-right: 10px;
                }
            `,
        },
    },
);

createAccountStyles.successSignUpMessage = mergeToNew(createAccountStyles.successSignUpMessage, {
    size: 16,
    weight: 400,

    css: css`
        text-align: left;
        margin-bottom: 0px;
    `,
});
